import { HTMLAttributes, useState } from "react";
import { useNavigate } from "@tanstack/react-router";

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CommonInstallflowFrame } from "./common-install-flow-frame";

interface AuthProps extends HTMLAttributes<HTMLDivElement> {}

export function AlreadyInstalled({ className }: AuthProps) {
    const navigate = useNavigate();
    
    const [unlinkModalOpen, setUnlinkModalOpen] = useState(false);

    function callTheModal() {
        setUnlinkModalOpen(true);
    }

    function handleUnlinkAndContinue() {
        setUnlinkModalOpen(false);
        navigate({ to: "/installFlow/install-not-started" });
        // TODO: navigate or perform unlink + continue flow
    }

    function handleCancel() {
        setUnlinkModalOpen(false);
    }

    return (
        <CommonInstallflowFrame>
            <div className="flex flex-col items-center justify-center gap-6 pt-[200px]">
                <h2 className="text-xl font-bold text-black leading-[26px]">Looks like this sensor was already installed. What would you like to do?</h2>
                <button
                    className="bg-white border-black-100 border-2 text-black w-full p-4 rounded-[12px] text-base font-semibold text-left h-[54px]"
                    onClick={() => callTheModal()}
                >
                    Install sensor or new asset
                </button>
                <button className="bg-white border-black-100 border-2 text-black w-full h-[54px] p-4 rounded-[12px] text-base font-semibold text-left">
                    Go to asset page
                </button>
            </div>

            <Dialog open={unlinkModalOpen} onOpenChange={setUnlinkModalOpen}>
                <DialogContent className="rounded-2xl border-0 shadow-xl sm:max-w-[calc(100%-2rem)]">
                    <DialogHeader>
                        <DialogTitle className="text-left text-lg font-bold text-black">
                            Are you sure?
                        </DialogTitle>
                        <DialogDescription className="text-left text-base text-black">
                            Installing this sensor on a new asset will unlink it from the current asset.
                        </DialogDescription>
                    </DialogHeader>
                    <DialogFooter className="flex flex-col gap-2 sm:flex-col">
                        <Button
                            variant="thalo"
                            className="w-full rounded-xl bg-[#0053EE] py-3 text-white hover:opacity-90"
                            onClick={handleUnlinkAndContinue}
                        >
                            Unlink & Continue
                        </Button>
                        <Button
                            variant="outline"
                            className="w-full rounded-xl border border-gray-200 bg-gray-100 py-3 text-gray-800 hover:bg-gray-200"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </CommonInstallflowFrame>
    );
}